import { logger } from "@/lib/logger";

const getBaseUrl = () => {
  const url = process.env.NEXT_PUBLIC_API_URL || process.env.API_URL;
  if (!url) return "";
  return url.trim().replace(/\/$/, "");
};

const BASE_URL = getBaseUrl();
const SERVER_SECRET =
  "H4KxWTUuPXWyhkxCq0AThQzDVrg7wRkIVeAuFim6uZJQJWDqvA8KWYKxqxhPejgY";

async function apiRequest(endpoint, options = {}) {
  const {
    params = {},
    body,
    headers = {},
    method = "GET",
    config = {},
  } = options;

  if (!BASE_URL) {
    console.error("API_URL is not defined in environment variables");

    if (typeof window === "undefined") return { data: null, ok: false };
  }

  if (!endpoint) {
    console.error("apiRequest called without endpoint!");
    return { data: null, ok: false, error: "Missing endpoint" };
  }

  let urlPath = String(endpoint);
  const queryParams = { ...params };

  Object.keys(params).forEach((key) => {
    if (urlPath.includes(`:${key}`)) {
      urlPath = urlPath.replace(`:${key}`, encodeURIComponent(params[key]));
      delete queryParams[key];
    }
  });

  let finalUrl;
  try {
    if (urlPath.startsWith("http://") || urlPath.startsWith("https://")) {
      finalUrl = new URL(urlPath);
    } else {
      const path = urlPath.replace(/^\/+/, "").replace(/\/+$/, "");
      if (BASE_URL.startsWith("http")) {
        finalUrl = new URL(`${BASE_URL}/${path}`);
      } else if (typeof window !== "undefined") {
        finalUrl = new URL(`${BASE_URL}/${path}`, window.location.origin);
      } else {
        finalUrl = new URL(`${BASE_URL}/${path}`, "http://localhost:3000");
      }
    }
  } catch (e) {
    console.error("Invalid URL construction:", {
      BASE_URL,
      urlPath,
      endpoint,
    });
    return { data: null, ok: false, error: e };
  }

  const url = finalUrl;

  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] !== undefined && queryParams[key] !== null) {
      if (typeof queryParams[key] === "object") {
        url.searchParams.append(key, JSON.stringify(queryParams[key]));
      } else {
        url.searchParams.append(key, queryParams[key]);
      }
    }
  });

  const isFormData = body instanceof FormData;

  const defaultHeaders = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    Accept: "application/json",
    "X-Server-Secret": SERVER_SECRET,
    ...headers,
  };

  try {
    const mergedConfig = config.config ? config.config : config;
    const { headers: configHeaders, ...restConfig } = mergedConfig || {};

    const fetchOptions = {
      method,
      body: isFormData ? body : body ? JSON.stringify(body) : undefined,
      // credentials:"include" on the server adds Cookie headers, which prevents
      // Next.js from storing responses in the Data Cache (tag-based revalidation breaks)
      ...(typeof window !== "undefined" && { credentials: "include" }),
      ...restConfig,
      headers: { ...defaultHeaders, ...configHeaders },
    };

    logger.log(`[API ${method}] ${url.toString()}`);
    const response = await fetch(url.toString(), fetchOptions);
    const data = await response.json();
    return { data, ok: response.ok, status: response.status };
  } catch (error) {
    console.error(`API request failed: ${url.toString()}`, error);
    return { data: null, ok: false, error };
  }
}

export const api = {
  get: (endpoint, params, config) =>
    apiRequest(endpoint, { params, config, method: "GET" }),
  post: (endpoint, body, paramsOrConfig, config) => {
    if (
      paramsOrConfig &&
      !config &&
      (paramsOrConfig.config ||
        paramsOrConfig.headers ||
        paramsOrConfig.params ||
        paramsOrConfig.cache ||
        paramsOrConfig.credentials)
    ) {
      return apiRequest(endpoint, {
        body,
        ...paramsOrConfig,
        method: "POST",
      });
    }
    return apiRequest(endpoint, {
      body,
      params: paramsOrConfig,
      config,
      method: "POST",
    });
  },
  put: (endpoint, body, paramsOrConfig, config) => {
    if (
      paramsOrConfig &&
      !config &&
      (paramsOrConfig.config ||
        paramsOrConfig.headers ||
        paramsOrConfig.params ||
        paramsOrConfig.cache ||
        paramsOrConfig.credentials)
    ) {
      return apiRequest(endpoint, {
        body,
        ...paramsOrConfig,
        method: "PUT",
      });
    }
    return apiRequest(endpoint, {
      body,
      params: paramsOrConfig,
      config,
      method: "PUT",
    });
  },
  delete: (endpoint, paramsOrConfig, config) => {
    if (
      paramsOrConfig &&
      !config &&
      (paramsOrConfig.config ||
        paramsOrConfig.headers ||
        paramsOrConfig.params ||
        paramsOrConfig.cache ||
        paramsOrConfig.credentials)
    ) {
      return apiRequest(endpoint, {
        ...paramsOrConfig,
        method: "DELETE",
      });
    }
    return apiRequest(endpoint, {
      params: paramsOrConfig,
      config,
      method: "DELETE",
    });
  },
};
